<template>
  <v-app>
    <app-header v-if="$route.meta.showMainHeader"></app-header>

    <header-mobile-admin v-if="$route.meta.showMobileHeaderAdmin"></header-mobile-admin>

    <left-panel v-if="$route.meta.showLeftPanel"></left-panel>

    

    <v-main>
      <!-- <v-container fluid> -->
        <router-view :key="$route.path"></router-view>
      <!-- </v-container> -->
    </v-main>


    <v-dialog
    v-model="dialogGeneralPopup"
    persistent
    max-width="400"
    >
      <v-card>

        <v-card-title :class="status == 'success'? 'text-h5 success--text' : 'text-h5 error--text'">
          <v-icon :color="status == 'success' ? 'success' : 'error'" class="mr-2">{{ icon }}</v-icon>
          {{title}}
        </v-card-title>

        <v-card-text class="black--text">
          {{text}}
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeDialog"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
    v-model="dialogLoginLocalhost"
    persistent
    max-width="290"
    >
      <v-card>

        <v-card-title class="text-h5">
          Localhost
        </v-card-title>
        
        <v-card-text class="black--text">
          <b>Developer Mode:</b>  Sila pilih domain for login portal localhost
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="goToLoginLocalhostPortal('jmg')"
          >
            JMG
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="goToLoginLocalhostPortal('alami')"
          >
            ALAMI
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-app>
</template>

<script>
import { bus } from '@/main';
import AppHeader from "@/components/AppHeader";
import HeaderMobile from "@/components/Admin/HeaderMobile";
import LeftPanel from "@/components/Admin/LeftPanel";
export default {
  name: "App",
  components: {
    "app-header": AppHeader,
    "header-mobile-admin": HeaderMobile,
    "left-panel": LeftPanel,
  },
  data: () => ({
    dialogGeneralPopup: false,
    status: "",
    icon: "",
    title: "",
    text: "",

    dialogLoginLocalhost: false,

    notaTambahan: ""
  }),
  mounted() {
    this.load();
  },
  methods: {

    load(){
      // let body = document.body.innerHTML;
      // console.log(body);
    },

    closeDialog(){

      if(this.notaTambahan == 'jumpToJoomla'){

          this.dialogGeneralPopup = false;
          window.location.assign(this.joomlaUrl);

      }
      else if(this.notaTambahan == 'jumpToLogout'){

          let codeToken = null;
          // let host = null;

          location.href.includes("code") == true? codeToken = location.href.split("?code=")[1] : codeToken = null;

          // if(location.host.includes("alami")){
          //   host = "";
          // }
          // else if(location.host.includes("8080")){
          //   host = "8080";
          // }
          // else if(location.host.includes("serasi")){
          //   host = "serasi";
          // }

          window.location.assign(this.loginPortalUrl)
  
          // let loginPortal8080 = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
          // host == "8080"? window.location.assign(loginPortal8080) : window.location.assign(this.loginPortalUrl);

      }
      else if(this.notaTambahan == 'optionLocalhostLoginDomain'){
          this.dialogGeneralPopup = false;
          this.dialogLoginLocalhost = true;
      }
      else{
          this.dialogGeneralPopup = false;
      }

      
    },

    goToLoginLocalhostPortal(data){

      let loginPortal8080 = "";
      if(data == 'jmg'){
        localStorage.setItem("localhostMyGEMSLogin", "jmg");
        loginPortal8080 = "https://mygems.jmg.gov.my/portal/sharing/rest/oauth2/authorize?client_id=MiW0HeUupa7Fxblz&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
      }
      else if(data == 'alami'){
        localStorage.setItem("localhostMyGEMSLogin", "alami");
        loginPortal8080 = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
      }
      
      this.setGlobalUrl();
      window.location.assign(loginPortal8080);

    }

  },
  created (){

        bus.$on('popupMessage', (data) => {

          this.status = data.result;

          if (data.result == "success") {
            this.icon = data.icon;
            this.title = data.title;
            this.text = data.text;
            this.dialogGeneralPopup = true;

            if(data.nota != undefined){
              this.notaTambahan = data.nota
            }

          }
          else if(data.result == "error"){
            this.icon = data.icon;
            this.title = data.title;
            this.text = data.text;
            this.dialogGeneralPopup = true;

            if(data.nota != undefined){
              this.notaTambahan = data.nota
            }

          }

        })
        
  },
};
</script>

<style lang="scss">



</style>
